import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";

const RecentBlog = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [recentPosts, setRecentPosts] = useState([]);

    useEffect(() => {
        const fetchRecentPosts = async () => {
            try {
                const cachedPosts = localStorage.getItem('recentPostsData');
                const cacheTimestamp = localStorage.getItem('recentPostsDataTimestamp');
                const now = Date.now();
                const THIRTY_MINUTES = 30 * 60 * 1000;

                if (cachedPosts && cacheTimestamp && (now - parseInt(cacheTimestamp) < THIRTY_MINUTES)) {
                    setRecentPosts(JSON.parse(cachedPosts));
                } else {
                    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
                    const Url = process.env.REACT_APP_API_RECENT_BLOGS;
                    const response = await axios.get(`${apiBaseUrl}${Url}`);

                    setRecentPosts(response.data);
                    localStorage.setItem('recentPostsData', JSON.stringify(response.data));
                    localStorage.setItem('recentPostsDataTimestamp', now.toString());
                }
            } catch (error) {
                console.error("Error fetching API", error);
            }
        };

        fetchRecentPosts();
    }, []);

    return (
        <div className="widget recent-post">
            <h5 className="widget-title">Recent Post</h5>
            {recentPosts.map((recentPost, index) => (
                <Link className='text-decoration-none' to={`/blog/details/${recentPost?.slug}`} key={index}>
                    <div className="recent-post-item">
                        <div className="recent-post-img">
                            <img src={`${backendBaseUrl}${recentPost?.image}`} alt={recentPost?.title} />
                        </div>
                        <div className="recent-post-info">
                            <h6 className='text-dark'>{recentPost?.title}</h6>
                            <span><i className="far fa-clock"></i>{new Date(recentPost?.published_date).toLocaleDateString('bn-BD', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}</span>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
}

export default RecentBlog;
